import React from 'react';
import { Login, SatCoreRegister } from 'sat-core';

const RegisterButtonExplanation = ({ t }) => {
  return (
    <div className='register-button-explanation'>
      {t('registerButtonExplanation')}
    </div>
  );
};

const LoginOverride = (props) => {
  return (
    <Login {...props}
      registerButtonExplanation={<RegisterButtonExplanation {...props} />}
      registrationMessageUrl='https://support.g-w.com/kb/section/112'
      shouldUseDefaultRegistrationMessage
      showFooter />
  );
};

SatCoreRegister('Login', LoginOverride);
